export type BamPromotionListStrings = {
    promoCode: string;
    noCodeNeeded: string;
    claim: string;
    learnMore: string;
    seeMore: string;
    seeAll: string;
    hide: string;
    specialOffer: string;
};

export const bamPromotionListStringsByLocale: Record<string, BamPromotionListStrings> = {
    en: {
        promoCode: 'Promo Code',
        noCodeNeeded: 'No Code Needed',
        claim: 'Claim',
        learnMore: 'Learn More',
        seeMore: 'See More',
        seeAll: 'See all',
        hide: 'Hide',
        specialOffer: 'Special Offer',
    },
    es: {
        promoCode: 'Codigo promocional',
        noCodeNeeded: 'No se necesita codigo',
        claim: 'Reclamar',
        learnMore: 'Saber mas',
        seeMore: 'Ver mas',
        seeAll: 'Ver todo',
        hide: 'Ocultar',
        specialOffer: 'Oferta especial',
    },
    fr: {
        promoCode: 'Code promo',
        noCodeNeeded: 'Aucun code requis',
        claim: 'Reclamer',
        learnMore: 'En savoir plus',
        seeMore: 'Voir plus',
        seeAll: 'Voir tout',
        hide: 'Masquer',
        specialOffer: 'Offre speciale',
    },
    de: {
        promoCode: 'Aktionscode',
        noCodeNeeded: 'Kein Code erforderlich',
        claim: 'Einloesen',
        learnMore: 'Mehr erfahren',
        seeMore: 'Mehr anzeigen',
        seeAll: 'Alle anzeigen',
        hide: 'Ausblenden',
        specialOffer: 'Sonderangebot',
    },
    sv: {
        promoCode: 'Kampanjkod',
        noCodeNeeded: 'Ingen kod behovs',
        claim: 'Hamta',
        learnMore: 'Lasa mer',
        seeMore: 'Läs mer',
        seeAll: 'Visa alla',
        hide: 'Dolj',
        specialOffer: 'Specialerbjudande',
    },
};
